export const AUD_DESKTOP_AUD2776_CIAN_ASSISTANT_ENTRY_POINT = 'aud_desktop_aud2776_cian_assistant_entry_point';
export const AUD_MOBILE_PROMO_CIAN_APPS = 'aud_mobile_aud3259_promo_cian_apps';

export const EXPERIMENTS = [AUD_DESKTOP_AUD2776_CIAN_ASSISTANT_ENTRY_POINT, AUD_MOBILE_PROMO_CIAN_APPS];
